/**
 * Client-safe Thai labels for the branch network.
 * Kept separate from registry.ts / meeting-points.ts so hub + detail routes can
 * render labels without pulling the full location corpora into the entry bundle.
 */
import type { MeetingPointKind } from "./meeting-point-kinds";

export const REGION_LABEL_TH: Record<string, string> = {
  bangkok: "กรุงเทพมหานคร",
  vicinity: "ปริมณฑล",
  north: "ภาคเหนือ",
  northeast: "ภาคตะวันออกเฉียงเหนือ",
  central: "ภาคกลาง",
  east: "ภาคตะวันออก",
  south: "ภาคใต้",
  overseas: "ต่างประเทศ",
};

export const KIND_LABEL_TH: Record<string, string> = {
  hq: "สำนักงานใหญ่",
  branch: "สำนักงานสาขา",
  "service-point": "จุดบริการ",
  airport: "จุดบริการสนามบิน",
  border: "พื้นที่ด่านชายแดน",
  government: "จุดประสานงานราชการ",
  "visa-center": "จุดประสานงานศูนย์วีซ่า",
  marina: "จุดบริการมารีน่า",
  "expat-hub": "พื้นที่ให้บริการชาวต่างชาติ",
  overseas: "เดสก์พันธมิตรต่างประเทศ",
};

export const MEETING_POINT_KIND_LABEL_TH: Record<MeetingPointKind, string> = {
  bts: "สถานี BTS",
  mrt: "สถานี MRT",
  arl: "สถานี Airport Rail Link",
  srt: "สถานีรถไฟฟ้าสายสีแดง",
  mall: "ศูนย์การค้า",
  airport: "สนามบิน",
};
